/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import router from '@/router'
import axios, { keycloak} from '../../api'

export default {
  login({ commit }, payload) {
    let params = new URLSearchParams();

    params.append('grant_type', payload.password);
    params.append('client_id', payload.client_id);
    params.append('username', payload.username);
    params.append('password', payload.password);
    return new Promise((resolve, reject) => {
      axios.post('https://stg.auth.traxi.mx/auth/realms/Traxi/protocol/openid-connect/token',params,{
        headers: {
          'Accept': 'application/json',
        }
      }).then(response=>{
        console.log(response);
      }).catch(error =>{
        console.log(error.response);
      })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve, reject) => {

    })
  },
  logout({ commit }, payload){
    keycloak.logout();
  }
}
